import { GoogleAnalytics } from "../../../App/global/functions/analytics";

let sendUserInformationtoGA = (window as any).GoogleAnalyticsBootstrap.sendUserInformationtoGA;

if (sendUserInformationtoGA && (sendUserInformationtoGA == "True" || sendUserInformationtoGA == "true")) {
    const analytics = new GoogleAnalytics();
    let lockedContentUniqueUserId = (window as any).GoogleAnalyticsBootstrap.lockedContentUniqueUserId;
    let userVisitorGroupName = (window as any).GoogleAnalyticsBootstrap.userVisitorGroupName;
    let currentUrl = (window as any).location.href;
    analytics.pushLockedContentUserInfo(currentUrl, lockedContentUniqueUserId, userVisitorGroupName);
}